import React from "react";
import PropTypes from "prop-types";
import "./ErrorDisplay.css";

function ErrorDisplay({ message }) {
  return (
    <div className="error-message">{message}</div>
  );
}

ErrorDisplay.propTypes = {
  message: PropTypes.string.isRequired
};

export default ErrorDisplay;
